module.exports = __webpack_public_path__ + "img/cropped-ralph-ravi-kayden-9VYBHWEoFfU-unsplash-lazy.848b7f2c.webp";